import React, { useEffect, useState } from "react";
import { taskApi } from "../../backend/client";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const QuoteDocForm = ({ taskId, onClose, onSave }: any) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    const fetchQuoteDoc = async () => {
      if (!taskId) return;

      const { data, error } = await taskApi.get(taskId);

      if (error) {
        setErrorMessage("Failed to fetch quote document link");
      } else if (data) {
        setLink(data.quote_link || "");
      }
    };

    fetchQuoteDoc();
  }, [taskId]);

  const handleSave = async (event) => {
    event?.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!link.trim()) {
      setErrorMessage("Quote document link is required");
      return;
    }

    const { error } = await taskApi.update(taskId, { quote_link: link });

    if (error) {
      setErrorMessage("Failed to save quote document link");
      return;
    }

    setSuccessMessage("Quote document link saved successfully.");
    onSave?.();
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-lg">
        <form className="space-y-5" onSubmit={handleSave}>
          <DialogHeader>
            <DialogTitle>Quote Document</DialogTitle>
            <DialogDescription>
              Save the OneDrive PDF link for the project quote.
            </DialogDescription>
          </DialogHeader>

          {errorMessage && (
            <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="rounded-md border border-tone-success-border bg-tone-success-surface px-3 py-2 text-sm text-tone-success-foreground">
              {successMessage}
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="quote-link">Quote OneDrive Link</Label>
            <Input
              id="quote-link"
              value={link}
              onChange={(event) => setLink(event.target.value)}
              placeholder="Paste OneDrive PDF link here"
              required
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteDocForm;
